export const tagDMP = {
  'Rufflesla Dalgana Bak': ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=Ruffles%203.0%20Content%20Readers'],
  Endeksa: ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=Endeksa%20Kategori%20Content%20Readers'],
  garantibonus: ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=Garanti%20BBVA%20Bonus%20Vitrin%20Kategori'],
  Qrobot: ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=content'],
  cinselyasam: [
    'https://dmp.adform.net/dmp/profile/?pid=10548&sg=Okey%20Category%20Readers',
    'https://dmp.adform.net/dmp/profile/?pid=12341&sg=P_O_1',
    'https://dmp.adform.net/dmp/profile/?pid=12341&sg=P_O_2',
  ],
  morphouykusu: ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=Kategori%20Morpho%20Sleep%20Readers'],
  urbanactivewellness: ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=Urban%20Active%20Category%20Readers'],
};
